import client from './client'

export default {
  async getThemeById (id) {
    const url = `/public/v2/theme/${id}`
    const res = await client.get(url)
    return res.data.data
  },
  async getHotThemeById (id) {
    const url = `/v5/theme/${id}`
    const res = await client.get(url)
    return res.data.data
  },
  async getCategoriesVideos (id, timestamp = Date.now(), page = 1, limit = 10) {
    const url = `/categories/${id}/videos`
    const res = await client.get(url, {
      params: {
        limit,
        page,
        timestamp
      }
    })
    return res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/apis/ultron-api/theme.js